function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 9a9 9 0 119 9c-2.49 0-4.73-1.01-6.36-2.64l1.42-1.42A6.944 6.944 0 0012.5 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7h3l-4.04 4.03-.07-.14L.5 9h3zm8 1V5H13v4.15l3.52 2.09-.77 1.28L11.5 10z",
  fill: "#000",
  fillOpacity: 0.54
});

var SvgIconHistory = function SvgIconHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/icon-history.2495d747.svg";
export { SvgIconHistory as ReactComponent };